import React from "react";
import StraightSvg from "./straight.svg";

interface StraightArrowProps {
    rotation?: number;
    count?: number;
    size?: number;
}

export const StraightArrow: React.FC<StraightArrowProps> = ({ rotation = 0, count, size = 60 }) => {
    return (
        <g transform={`rotate(${rotation})`}>
            <image href={StraightSvg} width={size} height={size} x={-size / 2} y={-size / 2} />
        </g>
    );
};
